export default __webpack_public_path__ + "media/images/mailer/icon_done-f49dc0b65c99f2edce1b99ee696f0b8d.png";